import { getAssetUrl, getAssetAudioUrl } from "./s3Links";

import allLevCompletedSrc from "../assets/images/allLevCompleted.svg";
import avatar1Src from "../assets/images/avatar1.png";
import avatar2Src from "../assets/images/avatar2.png";
import birthdayBoxImgSrc from "../assets/images/birthdayBoxImg.svg";
import chatLoaderSrc from "../assets/images/chatLoader.png";
import closeIconSrc from "../assets/images/closeIcon.svg";
import cloudPandaImgSrc from "../assets/images/cloudPandaImg.svg";
import confettiImgSrc from "../assets/images/confettiImg.svg";
import correctSrc from "../assets/images/correct.svg";
import correctTickSrc from "../assets/images/correctTick.svg";
import dogGifSrc from "../assets/images/dogGif.gif";
import frameSrc from "../assets/images/frame.svg";
import gameLostSrc from "../assets/images/gameLost.svg";
import graphSrc from "../assets/images/graph.svg";
import hintGifSrc from "../assets/images/hintGif.gif";
import hintNewSrc from "../assets/images/hintNew.svg";
import listeningImgSrc from "../assets/images/listeningImg.gif";
import micSrc from "../assets/mikee.svg";
import modalImgSrc from "../assets/images/modalImg.svg";
import musicIconSrc from "../assets/images/musicIcon.svg";
import nextimgSrc from "../assets/images/nextimg.svg";
import pandaImgSrc from "../assets/images/pandaImg.svg";
import pauseButtonImgSrc from "../assets/images/pauseButtonImg.png";
import pauseSrc from "../assets/images/pause.svg";
import playButtonImgSrc from "../assets/images/playButtonImg.svg";
import playImgSrc from "../assets/images/playImg.svg";
import pzMicSrc from "../assets/images/pzMic.svg";
import r2MileImgSrc from "../assets/images/r2MileImg.png";
import r3MileImgSrc from "../assets/images/r3MileImg.png";
import r3ResetSrc from "../assets/images/r3Reset.svg";
import r3WrongTickSrc from "../assets/images/r3WrongTick.svg";
import r4MileImgSrc from "../assets/images/r4MileImg.png";
import rOneMileImageSrc from "../assets/images/rOneMileImage.png";
import sandImgSrc from "../assets/images/sandImg.svg";
import starNewImgSrc from "../assets/images/starNewImg.svg";
import startButtonImgSrc from "../assets/images/startButtonImg.svg";
import startNewButtonImgSrc from "../assets/images/startNewButtonImg.png";
import startVoiceNoteSrc from "../assets/images/startVoiceNote.png";
import stopVoiceNoteSrc from "../assets/images/stopVoiceNote.png";
import tickImgSrc from "../assets/images/tickImg.svg";
import tickSrc from "../assets/images/tick.svg";
import turtleSrc from "../assets/images/turtle.svg";
import voiceImgSrc from "../assets/images/voiceImg.gif";
import wordsLearntSrc from "../assets/images/wordsLearnt.svg";
import wrongSrc from "../assets/images/wrong.svg";
import wrongTickSrc from "../assets/images/wrongTick.svg";
import xImgSrc from "../assets/images/xImg.svg";
import yellowLightImgSrc from "../assets/images/yellowLightImg.svg";
import zoomIconSrc from "../assets/images/zoomIcon.svg";

//Remote Assets

export const Apple = getAssetUrl("beffaf8b-4deb-4f0a-864a-22b6515beca9.svg");
export const Basket = getAssetUrl("52a672c4-a7a6-46e0-8634-f55d8b87114b.svg");
export const Bas = getAssetAudioUrl("a5c42b69-adac-4fc4-a84c-856bc7848227.wav");
export const BasketS = getAssetAudioUrl(
  "974a5a0d-763a-448a-9089-b5139c027c44.wav"
);
export const Jacket = getAssetUrl("e4259825-368b-4227-b059-e7fa06038c0f.png");
export const Jack = getAssetAudioUrl(
  "108546ef-0651-4278-bcfa-d586b4996198.wav"
);
export const Ket = getAssetAudioUrl("53532f41-854e-40ff-b4b6-27ec4b895fb4.wav");
export const JacketS = getAssetAudioUrl(
  "ea491e38-1e30-4fa7-8d57-20ff6a80a60f.wav"
);
export const Kit = getAssetAudioUrl("b7d9ce9e-fab8-4cf1-802d-3ed6e182b804.wav");
export const Ten = getAssetAudioUrl("44e88dce-e56b-4771-9457-e072ab90284c.wav");
export const KittenS = getAssetAudioUrl(
  "49e472b0-aa9f-489b-b347-522ed7a9d8e6.wav"
);
export const Pock = getAssetAudioUrl(
  "760bea68-6748-4bde-80c7-0f187e083e7c.wav"
);
export const Et = getAssetAudioUrl("6f41092a-9559-4610-befe-c6388bbdef2a.wav");
export const PocketS = getAssetAudioUrl(
  "83885333-0d2f-4859-ad8a-5d4350d18501.wav"
);
export const Rock = getAssetAudioUrl(
  "b683ca6d-5e10-44c0-8cbe-0d070ba3b99f.wav"
);
export const RocketS = getAssetAudioUrl(
  "73ebb6e6-f9ac-4e22-bc58-d7e432785970.wav"
);

export const GardenAudio = getAssetAudioUrl(
  "9af5d8cd-8ad3-4133-8784-da1f7d834724.wav"
);

export const basketImg = getAssetUrl(
  "7003caac-91f1-4212-8589-a0ffc356ef24.svg"
);
export const pencilImg = getAssetUrl(
  "94786804-563a-4e35-8c5b-575239fae375.svg"
);
export const sunsetImg = getAssetUrl(
  "8f69830a-5162-412c-9caf-23e7ee49518e.svg"
);
// export const paperImg =
//   "https://raw.githubusercontent.com/Sunbird-ALL/all-learner-ai-app/refs/heads/all-1.4.0-dev/src/assets/paperImg.png";
export const happyImg = getAssetUrl("697eaf81-b4f3-4c25-b16b-0238d145b225.jpg");
// export const candleImg =
//   "https://raw.githubusercontent.com/Sunbird-ALL/all-learner-ai-app/refs/heads/all-1.4.0-dev/src/assets/candleImg.jpeg";
export const gardenImg = getAssetUrl(
  "66a44587-d9f0-471f-92c0-e38d8420de64.png"
);

//export const ticketImg = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ticketImg.png";
export const trainStationImg = getAssetUrl(
  "76a3406f-52ac-4344-ad43-e2fa090ee01c.jpeg"
);

//---------------------//audios

//export const BasketAudio= "https://raw.githubusercontent.com/anik200002/EkstepImg/main/BasketAudio.wav";
//export const BottleAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/BottleAudio.wav";
//export const CrocodileAudio= getAssetAudioUrl("b03dcaa8-7cac-46f3-8e9f-6bfbd669e6b4.wav");
//export const PillowAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/PillowAudio.wav";
//export const TabletAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/TabletAudio.wav";
export const nextimg = nextimgSrc;
export const pzMic = pzMicSrc;
export const startVoiceNote = startVoiceNoteSrc;
export const stopVoiceNote = stopVoiceNoteSrc;
export const atm = getAssetUrl("c9423f27-c265-47e6-873f-d8b02f091cac.svg");
export const hintNew = hintNewSrc;
export const mall = getAssetUrl("3c6b6403-7f8d-457b-a626-f9b9411a1a63.svg");
export const beerImg = getAssetUrl("ff999033-08b7-4e6a-bc40-0bc1cad0cdb4.svg");
export const pandaImg = pandaImgSrc;
export const modalImg = modalImgSrc;
export const sunImg = getAssetUrl("9e3cd9b8-a08b-4a95-a899-23239661d47e.svg");
export const playImg = playImgSrc;
export const sandImg = sandImgSrc;
export const cloudPandaImg = cloudPandaImgSrc;
export const cloudyImg = getAssetUrl(
  "3b1e503d-3d01-4e7a-97e8-6ac491b22372.svg"
);

export const fishSwimImg = getAssetUrl(
  "94d83b92-9dd2-4785-a219-cabaa9b76d1f.svg"
);
export const birdsFlyImg = getAssetUrl(
  "df6a0d0f-0421-4344-a3b5-091343ea06e6.svg"
);
export const sheSmilesImg = getAssetUrl(
  "6298c2dd-fbe9-426f-bdbf-1b692be06910.svg"
);
export const theyLaughImg = getAssetUrl(
  "f386dfe0-4bed-4a72-88ef-e351acb9c05d.svg"
);
export const wePlayImg = getAssetUrl(
  "0040bedf-b33b-4d19-b67d-93fad96e4d29.svg"
);
export const heDancesImg = getAssetUrl(
  "7b5d454d-3817-4c47-8b9f-09a29c562a33.svg"
);
export const sheSingsImg = getAssetUrl(
  "c90a86c5-0370-4e7c-a49d-bdd4d8126e2d.svg"
);
export const dogsBarkImg = getAssetUrl(
  "21652c5c-d336-4764-9c48-b217ecc4bbf8.svg"
);
export const youCookImg = getAssetUrl(
  "128b80a6-64b1-44af-972c-9d54a6a2cfc9.svg"
);
export const weWinImg = getAssetUrl("c46271ca-f2d3-402d-a4ed-4d5ad066a1a9.svg");
export const itRainsImg = getAssetUrl(
  "e4007292-4371-4005-bb5e-ba10c1ec6a9c.svg"
);
export const youSwimImg = getAssetUrl(
  "cab4f0f3-64b4-4995-9d5b-7285ed5021d6.svg"
);
export const iSleepImg = getAssetUrl(
  "d4c77073-7e73-4bee-bf2b-c7dd353ebc42.svg"
);
export const heEatsImg = getAssetUrl(
  "f63042d6-ac51-407e-b7b8-a955650e8d7e.svg"
);
export const sheReadsImg = getAssetUrl(
  "f408ed19-8882-47b9-b138-87bc53d67807.svg"
);
export const clocksTickImg = getAssetUrl(
  "46240c95-f46b-4dff-a0fa-0182a93c4db7.svg"
);
export const flowersBloomImg = getAssetUrl(
  "4a56be2a-5172-4e89-994b-1dde648841fb.svg"
);
export const fireBurnsImg = getAssetUrl(
  "c2499a4e-5495-4a00-9019-9eb298f4a7ee.svg"
);
export const babyCriesImg = getAssetUrl(
  "ee651336-7e02-474f-b0aa-a5e8e655dd05.svg"
);
export const sunShinesImg = getAssetUrl(
  "b9470a33-3364-4759-993f-efc6a5b01787.svg"
);
export const appleAudio = getAssetAudioUrl(
  "2f93e134-c993-42d6-a47e-5dbb6a2a3b29.wav"
);
export const tigerAudio = getAssetAudioUrl(
  "6716ceee-4ce8-434a-a33f-1bcffd320793.wav"
);
export const happyAudio = getAssetAudioUrl(
  "9a091770-40db-4b39-927f-91176ebe8621.wav"
);
export const pencilAudio = getAssetAudioUrl(
  "ad45a9e8-ed8b-4d61-87ff-9216fd6b8b85.wav"
);
export const dinnerAudio = getAssetAudioUrl(
  "537d5fe4-3938-48fb-aebc-0ff35076732b.wav"
);
export const windowAudio = getAssetAudioUrl(
  "9b913ea1-0c92-4be7-b9ae-d299c11e9254.wav"
);
export const magnetAudio = getAssetAudioUrl(
  "e8228f46-4ab1-404c-8264-dd85ca1d338f.wav"
);
export const tennisAudio = getAssetAudioUrl(
  "2b1cedc8-b8c0-40ad-8e8d-b61465f68fcf.wav"
);
export const pictureAudio = getAssetAudioUrl(
  "fb57153a-6c4c-48d0-96e5-a9f8014fddcd.wav"
);
export const numberAudio = getAssetAudioUrl(
  "5eb79532-452b-414c-86ea-0ff5771b3db6.wav"
);
export const doctorAudio = getAssetAudioUrl(
  "c4bcedf0-174b-4808-8834-c614247c24b8.wav"
);
export const paperAudio = getAssetAudioUrl(
  "b4bf046c-2e17-49af-8344-0f752b9e99e2.wav"
);
export const monkeyAudio = getAssetAudioUrl(
  "a1e408d2-77ab-4172-9a8b-a3cf64a5aa74.wav"
);
export const helmetAudio = getAssetAudioUrl(
  "b2c0d4c3-438c-42ae-a20b-846597e449e8.wav"
);

export const apAudio = getAssetAudioUrl(
  "705fa258-adeb-4c3c-a485-70fd0752620f.wav"
);
export const tiAudio = getAssetAudioUrl(
  "9210b305-58b3-4531-b6b2-5b5674765132.wav"
);
export const hapAudio = getAssetAudioUrl(
  "ee71b02b-988a-44c5-b75f-5638184fe8a9.wav"
);
export const penAudio = getAssetAudioUrl(
  "a3531e30-36f0-4ddc-bd7a-0d3cf85041eb.wav"
);
export const dinAudio = getAssetAudioUrl(
  "86c063c3-5c9f-4bba-b73c-2233d259a031.wav"
);
export const winAudio = getAssetAudioUrl(
  "48d6013c-e6f1-4a86-988a-ba8871e81211.wav"
);
export const magAudio = getAssetAudioUrl(
  "befe6f8d-a284-4955-8f01-6f01a617e766.wav"
);
export const tenAudio = getAssetAudioUrl(
  "5c39a206-babe-4df6-ac9a-0ab709fb0b18.wav"
);
export const picAudio = getAssetAudioUrl(
  "92c7170b-c3c7-4fdd-a03e-4494778eb833.wav"
);
export const numAudio = getAssetAudioUrl(
  "66a5ce63-3c02-4c57-ba34-58d275365bfc.wav"
);
export const docAudio = getAssetAudioUrl(
  "fff36e67-acbd-4c37-a149-6a67ec7e2c81.wav"
);
export const paAudio = getAssetAudioUrl(
  "c7aa8a83-3c64-4beb-8c58-8da38f71d6fb.wav"
);
export const monAudio = getAssetAudioUrl(
  "88409e05-7b91-4986-85cc-4948df249e28.wav"
);
export const garAudio = getAssetAudioUrl(
  "59314cad-ab1f-47a6-8b96-e7c8d902388d.wav"
);
export const helAudio = getAssetAudioUrl(
  "931cd54a-7fcd-48f4-95df-7f2ce68bf12c.wav"
);
//export const dinAudio = getAssetAudioUrl("86c063c3-5c9f-4bba-b73c-2233d259a031.wav");
//export const dinAudio = getAssetAudioUrl("86c063c3-5c9f-4bba-b73c-2233d259a031.wav");
//export const butAudio = getAssetAudioUrl("de4ca892-afe3-4ccc-a360-b37c2897fd28.wav");
//export const winAudio = getAssetAudioUrl("48d6013c-e6f1-4a86-988a-ba8871e81211.wav");

export const pleAudio = getAssetAudioUrl(
  "24b80402-ee59-476a-9c4c-d565f2d8eac3.wav"
);
export const gerAudio = getAssetAudioUrl(
  "d921abf3-6eb9-4dca-b3ee-b2bad85a9a4c.wav"
);
export const pyAudio = getAssetAudioUrl(
  "38e7cfc6-59d3-466d-8cd1-e31b1f6c3d4b.wav"
);
export const cilAudio = getAssetAudioUrl(
  "8b3dbff9-5087-4688-8d2f-c4e56ce69584.wav"
);
export const nerAudio = getAssetAudioUrl(
  "a23b950d-78a1-4fad-917e-3bba3d046fdc.wav"
);
export const dowAudio = getAssetAudioUrl(
  "4ac0c83e-b336-4e21-95bb-a3dac3b380b5.wav"
);
export const netAudio = getAssetAudioUrl(
  "fd0cab72-081d-40a2-92a5-9673d6099e7c.wav"
);
export const nisAudio = getAssetAudioUrl(
  "9000c992-70bf-4a56-856f-c4f1530fda38.wav"
);
export const tureAudio = getAssetAudioUrl(
  "b1fa51d7-b97f-4396-a10e-631c0c0e4bb1.wav"
);
export const berAudio = getAssetAudioUrl(
  "bb88a4c5-2d8b-4982-bd9e-797758d9e5fe.wav"
);
export const torAudio = getAssetAudioUrl(
  "c115feea-9683-4021-85b3-536389e286e0.wav"
);
export const perAudio = getAssetAudioUrl(
  "437373e9-af76-463d-a787-b0e061ef8b2c.wav"
);
export const keyAudio = getAssetAudioUrl(
  "6f414c1f-1ca4-48c8-9d43-15178ff963e5.wav"
);
export const denAudio = getAssetAudioUrl(
  "bea4b104-658b-4e96-a9a4-bbf883a3a7b0.wav"
);
export const metAudio = getAssetAudioUrl(
  "78862918-c59e-4491-a69c-6b286051da02.wav"
);
// const nerAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/nerAudio.wav.wav";
//export const erAudio = getAssetAudioUrl("81004125-2761-4897-ba4d-da64ec2a21b9.wav");
//export const ketAudio = getAssetAudioUrl("7252f58f-cd56-43d2-82cd-ffef701321b8.wav");
//export const etAudio = getAssetAudioUrl("edb90529-4b7d-48c0-9d4a-2272ada659a3.wav");
//export const therAudio = getAssetAudioUrl("1fd541d2-42d3-4606-8d5f-5ca68ea0e31c.wav");
//export const dowAudio = getAssetAudioUrl("4ac0c83e-b336-4e21-95bb-a3dac3b380b5.wav");
//export const etAudio = getAssetAudioUrl("edb90529-4b7d-48c0-9d4a-2272ada659a3.wav");
//export const bleAudio = getAssetAudioUrl("0827df1e-8dc5-4377-b4a2-9dd2e2477603.wav");
// export const nerAudio = getAssetAudioUrl("a23b950d-78a1-4fad-917e-3bba3d046fdc.wav");
//export const derAudio = getAssetAudioUrl("2b9f8b1b-5e4d-4f6f-91fb-bb03e934d6ee.wav");
//export const tenAudio = getAssetAudioUrl("5c39a206-babe-4df6-ac9a-0ab709fb0b18.wav");
//export const terAudio = getAssetAudioUrl("3e006d87-8315-4393-a640-937b9e7bd808.wav");
//export const terAudio = getAssetAudioUrl("3e006d87-8315-4393-a640-937b9e7bd808.wav");
//export const gerAudio = getAssetAudioUrl("d921abf3-6eb9-4dca-b3ee-b2bad85a9a4c.wav");

export const wePlayAudio = getAssetAudioUrl(
  "28251e52-d625-4f72-99af-7034ea48ce27.wav"
);
export const sheReadsAudio = getAssetAudioUrl(
  "b10cd495-cebc-4e7c-bfd0-b320c9e622a4.wav"
);
export const heEatsAudio = getAssetAudioUrl(
  "46165e8c-ffec-4d2b-a01f-67bc58078be9.wav"
);
export const iSleepAudio = getAssetAudioUrl(
  "c984b904-958a-461f-92df-458053fb8da4.wav"
);
export const youSwimAudio = getAssetAudioUrl(
  "961fda79-0774-4e1f-997b-7f39481ecf04.wav"
);
export const sheSingsAudio = getAssetAudioUrl(
  "73c92135-2eae-486b-a5a5-32f63e877e61.wav"
);
export const heDancesAudio = getAssetAudioUrl(
  "0de1c0f4-b7b8-45ef-a501-1e7a459f2571.wav"
);
export const itRainsAudio = getAssetAudioUrl(
  "d60b1bee-1766-4a8c-9d78-0b7ed546671f.wav"
);
export const weWinAudio = getAssetAudioUrl(
  "676d100f-5f8d-4652-a57e-27d8d1e256e2.wav"
);
export const youCookAudio = getAssetAudioUrl(
  "0e5fa017-ea19-4b18-a25d-faaeeaa9cb3c.wav"
);
export const theyLaughAudio = getAssetAudioUrl(
  "074d8653-d2a8-4b57-9c55-02712f150c17.wav"
);
export const sheSmilesAudio = getAssetAudioUrl(
  "b6e65a0a-88d7-49b8-9d2d-01300a368ed0.wav"
);
export const birdsFlyAudio = getAssetAudioUrl(
  "5ebe2981-6a31-4d4e-ad46-fcc0ade35ec0.wav"
);
export const dogsBarkAudio = getAssetAudioUrl(
  "55f2ced9-7bd4-4822-88cd-2d33250abaea.wav"
);
export const fishSwimAudio = getAssetAudioUrl(
  "d4da941e-3ddf-4c97-9ffe-37b1bd790b0b.wav"
);
export const sunShinesAudio = getAssetAudioUrl(
  "a6d8206c-0e45-428d-ba3b-6a3087042590.wav"
);
export const babyCriesAudio = getAssetAudioUrl(
  "39d51738-4873-4011-b3d1-4f24eeb6cefa.wav"
);
export const fireBurnsAudio = getAssetAudioUrl(
  "96fbd8d4-c55b-43bc-a479-6dd39ce9f1f0.wav"
);
export const flowersBloomAudio = getAssetAudioUrl(
  "4056ca07-092e-4a1b-abba-277d9867f1ea.wav"
);
export const clocksTickAudio = getAssetAudioUrl(
  "ef5b5b69-fa3a-44cb-ad4b-5f474ad0cc3e.wav"
);

//export const taAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ta.wav.wav";
//export const terAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ter.wav.wav";
//export const apAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ap.wav.wav";

//export const paAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/pa.wav.wav";
//export const lemAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/lem.wav.wav";
//export const butAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/but.wav.wav";
// const coAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/co.wav.wav";
//export const magAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/mag.wav.wav";

//export const naAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/na.wav.wav";
//export const toAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/to.wav.wav";
//export const maAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ma.wav.wav";
//export const terAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ter.wav.wav";
//export const pleAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ple.wav.wav";
//export const tureAudio = "https://raw.githubusercontent.com/anik200002/EkstepImg/main/ture.wav.wav";
export const tickImg = tickImgSrc;
export const tick = tickSrc;
export const cloudNewImg = getAssetUrl(
  "14b8ff2f-63a7-4348-84ed-cb23aed4d608.svg"
);
export const xImg = xImgSrc;
export const GardenNewImg = getAssetUrl(
  "c312893e-70dd-4be0-a43c-4a2041570943.png"
);
export const MagnetNewImg = getAssetUrl(
  "93cfe968-2d41-48f2-8215-7d8285f4b5ff.png"
);
export const MonkeyNewImg = getAssetUrl(
  "6da6454f-5f36-4663-bc79-8f25a8452fdb.png"
);
export const NumberNewImg = getAssetUrl(
  "473844b7-bab5-4f5a-a4b9-f1fbbbbdb4fb.png"
);
export const PictureNewImg = getAssetUrl(
  "49e94573-180e-418a-9fff-676479bf7981.png"
);
export const RocketNewImg = getAssetUrl(
  "f8f7f1d4-2c99-49b9-b8df-e2c08f008067.png"
);
export const TennisNewImg = getAssetUrl(
  "d963f946-10e0-4dd3-b17e-655b975b6451.png"
);
export const TigerNewImg = getAssetUrl(
  "862eeffc-10c3-4077-b7bc-bba92474a1cc.png"
);
export const DoctorNewImg = getAssetUrl(
  "adeaf81b-1391-48bc-9d08-f0cb2f2acdfe.png"
);
export const frame = frameSrc;
export const mic = micSrc;
export const pause = pauseSrc;
export const wrongTick = wrongTickSrc;
export const graph = graphSrc;
export const rOneMileImage = rOneMileImageSrc;
export const hatR1TwoImg = getAssetUrl(
  "8580fe44-ab9c-405d-9155-e7c383f70b3b.svg"
);
export const hatR1ThreeImg = getAssetUrl(
  "6f125642-6c75-4f2c-b855-93a9e325d673.svg"
);
export const jugR1OneImg = getAssetUrl(
  "999fd2bc-263b-406c-86a9-d5753ef8805b.svg"
);
export const bagR1TwoImg = getAssetUrl(
  "84239e1b-47a2-4d64-9974-7307af815184.svg"
);
export const bagR1ThreeImg = getAssetUrl(
  "45e43ea9-bfc4-48a2-9b75-2110dbf1e54f.svg"
);
export const capR1TwoImg = getAssetUrl(
  "3ce9a59e-ca76-4e06-874d-9d231870a6d5.svg"
);
export const capR1ThreeImg = getAssetUrl(
  "ed15c082-3b6f-4b96-995b-80f53f86c092.svg"
);
export const dogR1TwoImg = getAssetUrl(
  "d9fd0d32-bacf-4ac1-837c-2d4407249ce0.svg"
);
export const dogR1ThreeImg = getAssetUrl(
  "85954ec0-b7c6-4d8e-8014-ffecb2736571.svg"
);
export const eggR1TwoImg = getAssetUrl(
  "2539dabf-f646-4450-9a72-eb0bb60d7105.svg"
);
export const eggR1ThreeImg = getAssetUrl(
  "8c092204-9b6f-46a4-8c05-e48def38ce45.svg"
);
export const fanR1OneImg = getAssetUrl(
  "448cfb1d-9bd1-4f76-b441-33e03b188032.svg"
);
export const fanR1TwoImg = getAssetUrl(
  "972b095b-7f11-4d90-8e3f-6b636c2a6b90.svg"
);
export const fanR1ThreeImg = getAssetUrl(
  "1dc17897-930a-4a6e-b66e-05554b25fa9e.svg"
);
export const ropeR1OneImg = getAssetUrl(
  "576c914d-7230-4de9-9e4c-d87bacfa3e52.svg"
);
export const ropeR1ThreeImg = getAssetUrl(
  "1d2d251d-e403-4364-9b9f-18f3a23c5801.svg"
);
export const pillowR1ThreeImg = getAssetUrl(
  "87780a61-8d36-4b2d-969c-5cac85a9b77f.svg"
);
export const shopImg = getAssetUrl("7427449c-bb7d-438d-8b27-7d94f62cc0c9.png");

export const playButtonImg = playButtonImgSrc;
export const pauseButtonImg = pauseButtonImgSrc;

export const questionPaperImg = getAssetUrl(
  "09573fee-0515-4520-868b-f47b0f90e036.jpg"
);

export const helmetImg = getAssetUrl(
  "d3cc5721-54b4-4a7b-8f59-8910e706f307.svg"
);
export const avatar1 = avatar1Src;
export const avatar2 = avatar2Src;
export const catImage = getAssetUrl("e494772d-fad8-4ea5-b969-4b843eb45c7d.png");
export const pocketImage = getAssetUrl(
  "c7c784ea-ef4f-418b-ac0e-f9b2cd415d9b.png"
);
export const DinnerNewImg = getAssetUrl(
  "01a0ff25-cb9b-4b44-ad40-67304f53a190.svg"
);
export const WindowNewImg = getAssetUrl(
  "b7463ddd-52b3-4eba-8ffa-bbebdd25c4d7.svg"
);
export const skyRImg = getAssetUrl("7d33ba6e-4c5a-489a-860e-4131087de891.svg");
export const shoutRImg = getAssetUrl(
  "1d01bfc0-02d7-4628-8a14-f727b46d654d.svg"
);
export const oilRImg = getAssetUrl("506bc546-9295-44ae-9dfe-a669e37c1091.svg");
export const drawRImg = getAssetUrl("b8ee16fe-9131-4f18-8cdf-df912ddd9c90.svg");
export const threeRImg = getAssetUrl(
  "013fca90-be0b-4819-afa4-1a26edd75165.svg"
);
export const deskRImg = getAssetUrl("5819ec5e-d6d1-4859-9c12-d94d5bf3812c.svg");
export const treasureRImg = getAssetUrl(
  "b0812e6b-e2a8-44d9-96db-3094ca0b34cd.svg"
);
export const scratchRImg = getAssetUrl(
  "b9224244-87db-492f-aecb-e1715a4fe5f4.svg"
);
export const listenRImg = getAssetUrl(
  "4d99cfa9-96f4-48aa-8d3f-361624fc7a29.svg"
);
export const pantherRImg = getAssetUrl(
  "32039297-07f5-4900-90f6-5f037d5572bf.svg"
);
export const streetRImg = getAssetUrl(
  "b52d17cd-ab18-4b85-9eb1-8dc6d6c30fa2.svg"
);
export const dragonRImg = getAssetUrl(
  "b6364716-e346-42e1-a82f-e007ec52c5f2.svg"
);
export const treeRImg = getAssetUrl("75245311-3647-4c0b-9556-ebbaac6f6255.svg");
export const spinRImg = getAssetUrl("0ce24e17-2345-4229-9a33-9b0a2c0222ee.svg");
export const StarRImg = getAssetUrl("c12fb8ba-46d1-42d2-b7c6-999b3cb1256c.svg");
export const orangeRImg = getAssetUrl(
  "6f4181d7-5c21-4383-afbe-157f2698d32a.svg"
);
export const whaleRImg = getAssetUrl(
  "ff9689ca-d4ad-4e12-aaae-ecc5b2d94b8c.svg"
);
export const phoneRImg = getAssetUrl(
  "71e6da69-b03c-4f0c-96c7-09458c2298a2.svg"
);
export const aimRImg = getAssetUrl("3f3a9861-6b9b-4ace-afcf-aaa8b0258b59.svg");
export const boatRImg = getAssetUrl("eb518b3c-5133-4219-bfc2-4e5c49019df6.svg");
export const clockRImg = getAssetUrl(
  "9ebad877-1d7f-460f-86e4-bce1ee25a4cb.svg"
);
export const flowerRImg = getAssetUrl(
  "d5b3815b-ab5e-4ebf-b58e-5aa299a464ee.svg"
);
export const glassRImg = getAssetUrl(
  "fd741cb3-01df-4e9d-ba15-c90d03eb6edb.svg"
);
export const sleepRImg = getAssetUrl(
  "2bb0ef9f-7b21-419d-a8bb-a34b1c603fda.svg"
);
export const elephantRImg = getAssetUrl(
  "dccc425e-f31b-4319-8ee2-e85a4dd199e6.svg"
);
export const muscleRImg = getAssetUrl(
  "f284b31e-ab7c-4dad-8d30-3d2bd7dc54ff.svg"
);
export const fieldRImg = getAssetUrl(
  "bfd38a9e-ae64-430a-ba4d-d5b00ca3c9ff.svg"
);
export const bicycleRImg = getAssetUrl(
  "a9b51d33-3616-4cbc-ab73-0eefc802d89c.svg"
);
export const mathsRImg = getAssetUrl(
  "bee9aba2-e20a-48c6-8ff0-c3f911e03b2f.svg"
);
export const glassRAudio = getAssetAudioUrl(
  "96cf4a59-7ec2-40d9-bfab-dabf64be521e.wav"
);
export const plantRAudio = getAssetAudioUrl(
  "47397b15-0a95-4fab-8141-f58232db0851.wav"
);
export const sleepRAudio = getAssetAudioUrl(
  "12e7d209-f3c1-443d-967d-01c12a7c5ce8.wav"
);
export const elephantRAudio = getAssetAudioUrl(
  "b9f8f8c8-f402-48a1-b431-c87a347a7078.wav"
);
export const muscleRAudio = getAssetAudioUrl(
  "c9eddf8b-ba2c-4640-867b-fd24a8c4ea54.wav"
);
export const fieldRAudio = getAssetAudioUrl(
  "5fa1548b-e7c4-4349-bbe0-77e31c50dcf3.wav"
);
export const bicycleRAudio = getAssetAudioUrl(
  "905bc420-ef4c-4c80-ae53-0439028e6a2a.wav"
);
export const mathsRAudio = getAssetAudioUrl(
  "4daa3187-398e-4ccc-bc30-14491a0b52f0.wav"
);
export const flowerRAudio = getAssetAudioUrl(
  "60dfee99-5ae5-4c59-9467-e8e1c60d6a0d.wav"
);
export const clockRAudio = getAssetAudioUrl(
  "ead6ec63-c474-4e9c-a7a0-0a2e26aa0989.wav"
);
export const orangeRAudio = getAssetAudioUrl(
  "8d29ba43-0524-409a-86e2-fdc60ef720a8.wav"
);
export const boatRAudio = getAssetAudioUrl(
  "4db1efe2-0f8f-4d34-9981-fa5fb2ff6648.wav"
);
export const aimRAudio = getAssetAudioUrl(
  "d3dd8af2-c6ef-4770-9fb8-09c463aa1f73.wav"
);
export const phoneRAudio = getAssetAudioUrl(
  "9707b58a-70e2-41da-b67f-9c148213097e.wav"
);
export const whaleRAudio = getAssetAudioUrl(
  "6fbbbfa7-a92c-4820-8d78-acf229d81b39.wav"
);
export const spinRAudio = getAssetAudioUrl(
  "81fa422e-0c26-4834-858e-8bb2e985f203.wav"
);
export const skyRAudio = getAssetAudioUrl(
  "71a224c7-5677-4789-a2bd-d5649517698c.wav"
);
export const treeRAudio = getAssetAudioUrl(
  "b82c87af-8b75-4e3c-97ff-27be9ccab0e5.wav"
);
export const dragonRAudio = getAssetAudioUrl(
  "74f6d322-0f9d-44ea-b9c7-94f96222faa2.wav"
);
export const oilRAudio = getAssetAudioUrl(
  "4d358e77-0859-4174-91c5-b29aa28a81a9.wav"
);
export const streetRAudio = getAssetAudioUrl(
  "d03aecee-1e0f-422e-9eb8-058b60037172.wav"
);
export const pantherRAudio = getAssetAudioUrl(
  "88dc4a95-478d-42eb-8f59-94409bf4173d.wav"
);
export const listenRAudio = getAssetAudioUrl(
  "34c7c9ed-4315-4d03-aa39-3519077bff7e.wav"
);
export const threeRAudio = getAssetAudioUrl(
  "59c91958-459b-4a74-89f0-9e4c3609d901.wav"
);
export const drawRAudio = getAssetAudioUrl(
  "7a64250a-6155-4803-a31e-8ffb1926b76e.wav"
);
export const scratchRAudio = getAssetAudioUrl(
  "38d08efe-697d-4b57-b773-00e236e6085d.wav"
);
export const treasureRAudio = getAssetAudioUrl(
  "5d8eeb7b-ddba-46b3-8a1a-dac9c8af4163.wav"
);
export const deskRAudio = getAssetAudioUrl(
  "826e0d57-6f61-4e6f-8022-8c588abcce8e.wav"
);
export const shoutRAudio = getAssetAudioUrl(
  "23b4baf5-0d78-4657-b70e-9648ab00e062.wav"
);
export const starRAudio = getAssetAudioUrl(
  "07b7247f-1f3a-4ff8-bc75-e7ea9dfb1d47.wav"
);
export const railAnouncementImg = getAssetUrl(
  "90f6fe7f-bcb0-45b9-8f6e-09e9ab019b4b.svg"
);
export const listeningImg = listeningImgSrc;
export const voiceImg = voiceImgSrc;

export const musicIcon = musicIconSrc;
export const chatLoader = chatLoaderSrc;
export const starNewImg = starNewImgSrc;
export const zoomIcon = zoomIconSrc;
export const closeIcon = closeIconSrc;
export const allLevCompleted = allLevCompletedSrc;
export const r2MileImg = r2MileImgSrc;
export const r3MileImg = r3MileImgSrc;
export const r4MileImg = r4MileImgSrc;
export const dogGif = dogGifSrc;
export const hintGif = hintGifSrc;
export const r3WrongTick = r3WrongTickSrc;
export const r3Reset = r3ResetSrc;
export const correctTick = correctTickSrc;
export const books = getAssetUrl("66859d34-4139-484c-90af-2ec9a0596676.svg");
export const clock = getAssetUrl("c79db419-a61e-44cc-a191-2cf51fef80e9.svg");
export const wordsLearnt = wordsLearntSrc;

export const startNewButtonImg = startNewButtonImgSrc;
export const startButtonImg = startButtonImgSrc;
export const birthdayBoxImg = birthdayBoxImgSrc;
export const confettiImg = confettiImgSrc;
export const yellowLightImg = yellowLightImgSrc;

// Temp fix

export const correct = correctSrc;
export const gameLost = gameLostSrc;
export const turtle = turtleSrc;
export const wrong = wrongSrc;
